import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/@core-auth';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class UnauthorizedInterceptor implements HttpInterceptor {
  private readonly _apiUrl: string;
  constructor(private router: Router, private auth: AuthService) {
    this._apiUrl = environment.apiUrl;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter(event => {
        if (request.url.indexOf(this._apiUrl) > -1 && event instanceof HttpResponse) {
          if (this.checkIfUnauthorized(event as HttpResponse<any>)) {
            this.auth.logout();
            this.router.navigate(['/auth/login']);
            return false;
          }
        }

        return true;
      })
    );
  }

  private checkIfUnauthorized(request: HttpResponse<any>): boolean {
    return (
      request.body &&
      request.body.errors &&
      request.body.errors.filter(err => err && err.extensions).some(err => err.extensions.code === 'authorization')
    );
  }
}
